import { Befehl } from '../models'
import {
  findAuftrag,
  hasField,
  hasEitherField,
  hasMissingWertOrEmptyFreitextField,
  hasMissingWertOrEmptySignalField,
  hasMissingWertOrEmptyKmhField,
  hasMissingWertOrEmptyKmField,
  hasMissingWertOrEmptyZugmeldestelle
} from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 6 has empty fields.
 *
 * Conditions:
 * - At least fields 6.43, one of [6.47.1, 6.47.2] and one of [6.48.1, 6.48.2] must exist
 * - All existing fields must not be empty
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl6EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag640 = findAuftrag(befehl, '6.40')
  const auftrag641 = findAuftrag(befehl, '6.41')
  const auftrag690 = findAuftrag(befehl, '6.90')
  const auftrag695 = findAuftrag(befehl, '6.95')

  // Check if required fields are missing (because required selections in Befehl form were not made)
  if (
    !hasField(auftrag640, '6.43') ||
    !hasEitherField(auftrag640, '6.47.1', '6.47.2') ||
    !hasEitherField(auftrag640, '6.48.1', '6.48.2')
  ) {
    return true
  }

  // Check if existing fields have missing werte or are not empty
  return (
    hasMissingWertOrEmptyZugmeldestelle(auftrag640, '6.43') ||
    hasMissingWertOrEmptyZugmeldestelle(auftrag640, '6.44') ||
    hasMissingWertOrEmptyKmField(auftrag640, '6.47.1') ||
    hasMissingWertOrEmptyKmField(auftrag640, '6.48.1') ||
    hasMissingWertOrEmptySignalField(auftrag640, '6.47.2') ||
    hasMissingWertOrEmptySignalField(auftrag640, '6.48.2') ||
    // Check if auftrag 6.41 has empty fields
    hasMissingWertOrEmptyKmhField(auftrag641, '6.42.1') ||
    // Check if auftrag 6.90 has empty fields
    hasMissingWertOrEmptyFreitextField(auftrag690, '6.91') ||
    hasMissingWertOrEmptyFreitextField(auftrag690, '6.92') ||
    // Check if auftrag 6.95 has empty fields
    hasMissingWertOrEmptyFreitextField(auftrag695, '6.96')
  )
}
